import { render } from "./TrayMenu.vue?vue&type=template&id=2d917e46&scoped=true"
import script from "./TrayMenu.vue?vue&type=script&lang=js"
export * from "./TrayMenu.vue?vue&type=script&lang=js"

import "./TrayMenu.vue?vue&type=style&index=0&id=2d917e46&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d917e46"]])

export default __exports__